export const FETCH_CATEGORY_REQUEST = "FETCH_CATEGORY_REQUEST";
export const FETCH_CATEGORY_SUCCESS = "FETCH_CATEGORY_SUCCESS";
export const FETCH_CATEGORY_FAILURE = "FETCH_CATEGORY_FAILURE";

export const FETCH_CATEGORY_SECTIONS_REQUEST =
  "FETCH_CATEGORY_SECTIONS_REQUEST";
export const FETCH_CATEGORY_SECTIONS_SUCCESS =
  "FETCH_CATEGORY_SECTIONS_SUCCESS";
export const FETCH_CATEGORY_SECTIONS_FAILURE =
  "FETCH_CATEGORY_SECTIONS_FAILURE";

export const POSITION_CATEGORY_SECTION_REQUEST =
  "POSITION_CATEGORY_SECTION_REQUEST";
export const POSITION_CATEGORY_SECTION_SUCCESS =
  "POSITION_CATEGORY_SECTION_SUCCESS";
export const POSITION_CATEGORY_SECTION_FAILURE =
  "POSITION_CATEGORY_SECTION_FAILURE";

export const MOVE_CATEGORY_SECTION_TO_TOP_REQUEST =
  "MOVE_CATEGORY_SECTION_TO_TOP_REQUEST";
export const MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS =
  "MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS";
export const MOVE_CATEGORY_SECTION_TO_TOP_FAILURE =
  "MOVE_CATEGORY_SECTION_TO_TOP_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/category/types.js